/**
 * Sales > Stats. Tabs-updates: a data-set dropdown + date-range filter
 * driving a (code-split) Recharts bar chart over the leads/opportunities
 * metric catalogue.
 */

import { createFileRoute } from '@tanstack/react-router';

import { StatsView } from '@/components/sales/StatsView';

export const Route = createFileRoute('/sales/stats')({
  component: () => <StatsView />,
});
